/**
 * How long each intake box may be - C-129.
 *
 * **Restated from `server/src/http/fieldLimits.ts` on purpose, and guarded**,
 * on the `euCountries` precedent: the client cannot import from the server
 * workspace, and `fieldLimits.test.ts` reads the server's file off disk and
 * fails if the two differ. Change the server's first.
 *
 * One number for a business name, used by the project name, the order's target
 * name and the footer's business name, because the footer is prefilled from
 * the other two and `maxLength` cannot shorten a value it did not see typed.
 */
export const FIELD_LIMITS = {
  businessName: 200,
  targetLocation: 50,
  linkWording: 80,
  footerPhone: 30,
  footerAddressLine: 60,
  footerCity: 50,
  footerRegion: 50,
  footerPostcode: 15,
} as const;
